// questionData.ts
// Pure question data objects - no behavior, only content
// This will be auto-generated from DIAGRAM.md by the parser

import type { QuestionData } from '../machines/surveyMachine.types';

/**
 * Question data registry
 * Maps state names to question content
 * The state machine uses these for rendering
 */
export const questionDataMap: Record<string, QuestionData> = {
  Q1: {
    id: 'Q1',
    diagramId: 'Q1',
    questionNumber: 1,
    displayNumber: '1)',
    questionText: 'About you (screening & inclusion)\nWhich best describes your current status?',
    type: 'single-choice',
    options: [
      "I'm working in Portugal (Portuguese national)",
      "I'm working in Portugal (immigrant/expat, not Portuguese)",
      "I'm unemployed and job searching in Portugal",
      "I used to live/work in Portugal, but now I'm abroad",
      "Living in Portugal but not working"
    ],
    required: true,
    path: 'common',
    blockNumber: 0,
    accentColor: '#ffffff',
  },

  Q2_Industry: {
    id: 'Q2_Industry',
    diagramId: 'Q2_Industry',
    questionNumber: 2,
    displayNumber: '2)',
    questionText: 'Which industry best describes your current/most recent work?',
    type: 'single-choice',
    options: [
      'Tech/Software',
      'Finance/Banking',
      'Healthcare',
      'Education',
      'Retail/Commerce',
      'Manufacturing',
      'Services',
      'Other'
    ],
    required: true,
    path: 'common',
    blockNumber: 0,
  },

  // Path A Questions - Block 1
  Q2A: {
    id: 'Q2A',
    diagramId: 'Q2A',
    questionNumber: 2,
    displayNumber: '2)',
    questionText: 'What workplace arrangement do you currently have?',
    type: 'single-choice',
    options: ['Fully remote', 'Hybrid', 'Fully onsite'],
    required: true,
    path: 'A',
    blockNumber: 1,
    accentColor: '#e8f5e8',
  },

  Q3A: {
    id: 'Q3A',
    diagramId: 'Q3A',
    questionNumber: 3,
    displayNumber: '3)',
    questionText: 'Have you thought about leaving Portugal for better work?',
    type: 'single-choice',
    options: ['Yes', 'No', 'Maybe'],
    required: true,
    path: 'A',
    blockNumber: 1,
    accentColor: '#e8f5e8',
  },

  Q3A_Alt: {
    id: 'Q3A_Alt',
    diagramId: 'Q3A_Alt',
    questionNumber: 3,
    displayNumber: '3a)',
    questionText: 'Which arrangement would you prefer?',
    type: 'single-choice',
    options: ['Fully remote', 'Hybrid', 'Fully onsite'],
    required: true,
    path: 'A',
    blockNumber: 1,
    accentColor: '#e8f5e8',
  },

  Q4A_Hours: {
    id: 'Q4A_Hours',
    diagramId: 'Q4A_Hours',
    questionNumber: 4,
    displayNumber: '4)',
    questionText: 'How many hours do you usually work per week?',
    type: 'single-choice',
    options: ['<35', '35–40', '41–50', '51+'],
    required: true,
    path: 'A',
    blockNumber: 1,
    accentColor: '#e8f5e8',
  },

  // Path B Questions - Block 1
  Q2B: {
    id: 'Q2B',
    diagramId: 'Q2B',
    questionNumber: 2,
    displayNumber: '2)',
    questionText: 'How long have you been job searching?',
    type: 'single-choice',
    options: ['Less than 3 months', '3–12 months', 'Over 1 year'],
    required: true,
    path: 'B',
    blockNumber: 1,
    accentColor: '#fff3e0',
  },

  Q3B: {
    id: 'Q3B',
    diagramId: 'Q3B',
    questionNumber: 3,
    displayNumber: '3)',
    questionText: 'Biggest barrier you face in finding work?',
    type: 'single-choice',
    options: [
      'Low pay',
      'Few opportunities',
      'Skills mismatch',
      'Age bias',
      'Language/cultural barriers',
      'Other'
    ],
    required: true,
    path: 'B',
    blockNumber: 1,
    accentColor: '#fff3e0',
  },

  Q4B: {
    id: 'Q4B',
    diagramId: 'Q4B',
    questionNumber: 4,
    displayNumber: '4)',
    questionText: 'Would you return to Portugal if work conditions improved?',
    type: 'single-choice',
    options: ['Yes', 'No', 'Maybe'],
    required: true,
    path: 'B',
    blockNumber: 1,
    accentColor: '#fff3e0',
  },

  Q5B: {
    id: 'Q5B',
    diagramId: 'Q5B',
    questionNumber: 5,
    displayNumber: '5)',
    questionText: 'From abroad, how do you see the Portuguese job market?',
    type: 'single-choice',
    options: [
      'A good place to work',
      'Stuck in the past',
      'Slowly getting better',
      'Other'
    ],
    required: true,
    path: 'B',
    blockNumber: 1,
    accentColor: '#fff3e0',
  },

  // Path C Questions - Block 1
  Q2C: {
    id: 'Q2C',
    diagramId: 'Q2C',
    questionNumber: 2,
    displayNumber: '2)',
    questionText: 'Why did you leave Portugal for work?',
    type: 'single-choice',
    options: [
      'Better pay',
      'Better career growth',
      'Flexibility',
      'Stability',
      'Other'
    ],
    required: true,
    path: 'C',
    blockNumber: 1,
    accentColor: '#f3e5f5',
  },

  Q3C: {
    id: 'Q3C',
    diagramId: 'Q3C',
    questionNumber: 3,
    displayNumber: '3)',
    questionText: 'Would you return to Portugal if work conditions improved?',
    type: 'single-choice',
    options: ['Yes', 'No', 'Maybe'],
    required: true,
    path: 'C',
    blockNumber: 1,
    accentColor: '#f3e5f5',
  },

  Q4C: {
    id: 'Q4C',
    diagramId: 'Q4C',
    questionNumber: 4,
    displayNumber: '4)',
    questionText: 'Would you return to Portugal if work conditions improved?',
    type: 'single-choice',
    options: ['Yes', 'No', 'Maybe'],
    required: true,
    path: 'C',
    blockNumber: 1,
    accentColor: '#f3e5f5',
  },

  Q5C: {
    id: 'Q5C',
    diagramId: 'Q5C',
    questionNumber: 5,
    displayNumber: '5)',
    questionText: 'If you wanted to work in Portugal, what would matter most to you? (pick two)',
    type: 'multi-choice',
    options: [
      'Salary',
      'Flexibility',
      'Career growth',
      'Stability',
      'Benefits',
      'Work-life balance'
    ],
    maxSelections: 2,
    required: true,
    path: 'C',
    blockNumber: 1,
    accentColor: '#f3e5f5',
  },

  // Path D Questions - Block 1
  Q2D: {
    id: 'Q2D',
    diagramId: 'Q2D',
    questionNumber: 2,
    displayNumber: '2)',
    questionText: 'Have you ever worked in Portugal?',
    type: 'single-choice',
    options: ['Yes, in the past', 'No, not yet'],
    required: true,
    path: 'D',
    blockNumber: 1,
    accentColor: '#e3f2fd',
  },

  Q3D_A: {
    id: 'Q3D_A',
    diagramId: 'Q3D_A',
    questionNumber: 3,
    displayNumber: '3a)',
    questionText: 'If yes, how would you describe that past work experience in Portugal?',
    type: 'open-short',
    placeholder: 'Share your experience...',
    required: true,
    path: 'D',
    blockNumber: 1,
    accentColor: '#e3f2fd',
  },

  Q3D_B: {
    id: 'Q3D_B',
    diagramId: 'Q3D_B',
    questionNumber: 3,
    displayNumber: '3b)',
    questionText: "If no, what's the main reason you haven't worked here?",
    type: 'single-choice',
    options: [
      "I'm studying",
      "I'm retired",
      "I'm caring for family",
      "I couldn't find suitable work",
      'Other'
    ],
    required: true,
    path: 'D',
    blockNumber: 1,
    accentColor: '#e3f2fd',
  },

  Q4D: {
    id: 'Q4D',
    diagramId: 'Q4D',
    questionNumber: 4,
    displayNumber: '4)',
    questionText: 'Do you think Portugal offers fair opportunities for people like you to find work?',
    type: 'single-choice',
    options: ['Yes', 'No', 'Not sure'],
    required: true,
    path: 'D',
    blockNumber: 1,
    accentColor: '#e3f2fd',
  },

  Q5D: {
    id: 'Q5D',
    diagramId: 'Q5D',
    questionNumber: 5,
    displayNumber: '5)',
    questionText: "What's your biggest concern about work in Portugal?",
    type: 'single-choice',
    options: [
      'Low wages',
      'Limited opportunities',
      'Work-life balance',
      'Job security',
      'Other'
    ],
    required: true,
    path: 'D',
    blockNumber: 1,
    accentColor: '#e3f2fd',
  },

  // Path A - Block 2
  Q5A: {
    id: 'Q5A',
    diagramId: 'Q5A',
    questionNumber: 5,
    displayNumber: '5)',
    questionText: 'Are there dress code restrictions where you work?',
    type: 'single-choice',
    options: ['Yes, strict', 'Yes, but loose', 'None at all'],
    required: true,
    path: 'A',
    blockNumber: 2,
    accentColor: '#e8f5e8',
  },

  Q6A: {
    id: 'Q6A',
    diagramId: 'Q6A',
    questionNumber: 6,
    displayNumber: '6)',
    questionText: "What do you think about 'dress codes' at work?",
    type: 'single-choice',
    options: [
      "They're outdated and restrictive — let people dress how they want.",
      "They're useful — some standards at work are fine.",
      "Neutral — doesn't matter much either way."
    ],
    required: true,
    path: 'A',
    blockNumber: 2,
    accentColor: '#e8f5e8',
  },

  // Path B - Block 2
  Q6B: {
    id: 'Q6B',
    diagramId: 'Q6B',
    questionNumber: 6,
    displayNumber: '6)',
    questionText: 'Do you think younger generations in Portugal will have it easier or harder at work?',
    type: 'single-choice',
    options: ['Easier', 'Harder', 'About the same'],
    required: true,
    path: 'B',
    blockNumber: 2,
    accentColor: '#fff3e0',
  },

  Q7B: {
    id: 'Q7B',
    diagramId: 'Q7B',
    questionNumber: 7,
    displayNumber: '7)',
    questionText: 'Be honest: do you think Portugal is a good place to work?',
    type: 'single-choice',
    options: ['Love it', 'Meh', 'Hate it'],
    required: true,
    path: 'B',
    blockNumber: 2,
    accentColor: '#fff3e0',
  },

  Q8B: {
    id: 'Q8B',
    diagramId: 'Q8B',
    questionNumber: 8,
    displayNumber: '8)',
    questionText: "If you could change one thing about Portugal's job market, what would it be?",
    type: 'open-short',
    placeholder: 'Your answer...',
    required: true,
    path: 'B',
    blockNumber: 2,
    accentColor: '#fff3e0',
  },

  Q9B: {
    id: 'Q9B',
    diagramId: 'Q9B',
    questionNumber: 9,
    displayNumber: '9)',
    questionText: 'One word that describes your job search in Portugal.',
    type: 'open-short',
    placeholder: 'One word...',
    required: true,
    path: 'B',
    blockNumber: 2,
    accentColor: '#fff3e0',
  },

  // Path C - Block 2
  Q6C: {
    id: 'Q6C',
    diagramId: 'Q6C',
    questionNumber: 6,
    displayNumber: '6)',
    questionText: 'Do you think younger generations in Portugal will have it easier or harder at work?',
    type: 'single-choice',
    options: ['Easier', 'Harder', 'About the same'],
    required: true,
    path: 'C',
    blockNumber: 2,
    accentColor: '#f3e5f5',
  },

  Q7C: {
    id: 'Q7C',
    diagramId: 'Q7C',
    questionNumber: 7,
    displayNumber: '7)',
    questionText: "Thinking back: how would you describe workplace 'dress code culture' in Portugal?",
    type: 'single-choice',
    options: ['Too rigid', 'Reasonable', 'Non-existent', 'Other'],
    required: true,
    path: 'C',
    blockNumber: 2,
    accentColor: '#f3e5f5',
  },

  Q8C: {
    id: 'Q8C',
    diagramId: 'Q8C',
    questionNumber: 8,
    displayNumber: '8)',
    questionText: 'One word that describes Portuguese work culture.',
    type: 'open-short',
    placeholder: 'One word...',
    required: true,
    path: 'C',
    blockNumber: 2,
    accentColor: '#f3e5f5',
  },

  // Path D - Block 2
  Q6D: {
    id: 'Q6D',
    diagramId: 'Q6D',
    questionNumber: 6,
    displayNumber: '6)',
    questionText: 'One word that describes how you see work culture in Portugal.',
    type: 'open-short',
    placeholder: 'One word...',
    required: true,
    path: 'D',
    blockNumber: 2,
    accentColor: '#e3f2fd',
  },

  // Path A - Block 3 (only Path A has Block 3)
  Q7A_Matters: {
    id: 'Q7A_Matters',
    diagramId: 'Q7A_Matters',
    questionNumber: 7,
    displayNumber: '7)',
    questionText: 'What matters most to you in your job? (Pick two)',
    type: 'multi-choice',
    options: [
      'Salary',
      'Flexibility',
      'Career growth',
      'Stability',
      'Benefits',
      'Work-life balance'
    ],
    maxSelections: 2,
    required: true,
    path: 'A',
    blockNumber: 3,
    accentColor: '#e8f5e8',
  },

  Q8A_Paid: {
    id: 'Q8A_Paid',
    diagramId: 'Q8A_Paid',
    questionNumber: 8,
    displayNumber: '8)',
    questionText: 'Do you feel fairly paid for the work you do?',
    description: "[Only shown if 'Salary' selected in Q7]",
    type: 'single-choice',
    options: ['Yes', 'Somewhat', 'No'],
    required: true,
    path: 'A',
    blockNumber: 3,
    accentColor: '#e8f5e8',
  },

  Q9A_Eating: {
    id: 'Q9A_Eating',
    diagramId: 'Q9A_Eating',
    questionNumber: 9,
    displayNumber: '9)',
    questionText: "Have you ever felt your job is 'eating you alive'?",
    type: 'single-choice',
    options: ['Yes', 'No'],
    required: true,
    path: 'A',
    blockNumber: 3,
    accentColor: '#e8f5e8',
  },

  Q10A_Like: {
    id: 'Q10A_Like',
    diagramId: 'Q10A_Like',
    questionNumber: 10,
    displayNumber: '10)',
    questionText: 'Be honest: do you like working in Portugal?',
    type: 'single-choice',
    options: ['Love it', 'Meh', 'Hate it'],
    required: true,
    path: 'A',
    blockNumber: 3,
    accentColor: '#e8f5e8',
  },

  Q11A_Freedom: {
    id: 'Q11A_Freedom',
    diagramId: 'Q11A_Freedom',
    questionNumber: 11,
    displayNumber: '11)',
    questionText: 'Does your job give you freedom — or does it feel like a prison in a suit?',
    type: 'single-choice',
    options: ['Freedom', 'Prison', 'Somewhere in between'],
    required: true,
    path: 'A',
    blockNumber: 3,
    accentColor: '#e8f5e8',
  },

  Q12A_Quit: {
    id: 'Q12A_Quit',
    diagramId: 'Q12A_Quit',
    questionNumber: 12,
    displayNumber: '12)',
    questionText: 'If you could quit tomorrow, would you? Why (or why not)?',
    type: 'open-long',
    placeholder: 'Share your thoughts...',
    multiline: true,
    required: true,
    path: 'A',
    blockNumber: 3,
    accentColor: '#e8f5e8',
  },

  Q13A_Career_Build: {
    id: 'Q13A_Career_Build',
    diagramId: 'Q13A_Career_Build',
    questionNumber: 13,
    displayNumber: '13)',
    questionText: 'Do you think you can build a real career in Portugal, or would you have to leave?',
    type: 'single-choice',
    options: ['I can build here', "I'd have to leave", 'Not sure'],
    required: true,
    path: 'A',
    blockNumber: 3,
    accentColor: '#e8f5e8',
  },

  Q14A_Job_Word: {
    id: 'Q14A_Job_Word',
    diagramId: 'Q14A_Job_Word',
    questionNumber: 14,
    displayNumber: '14)',
    questionText: 'If you had to describe your job in one word, what would it be?',
    type: 'open-short',
    placeholder: 'One word...',
    required: true,
    path: 'A',
    blockNumber: 3,
    accentColor: '#e8f5e8',
  },

  // Final questions
  Final_Questions: {
    id: 'Final_Questions',
    diagramId: 'Final_Questions',
    questionNumber: 15,
    displayNumber: '15)',
    questionText: "Any frustrations, dreams, or hopes about work you'd like to share?",
    type: 'open-long',
    placeholder: 'Share your thoughts (optional)...',
    multiline: true,
    required: false,
    path: null,
    blockNumber: 'final',
    accentColor: '#fff8e1',
  },

  Final_Email: {
    id: 'Final_Email',
    diagramId: 'Final_Email',
    questionNumber: 16,
    displayNumber: '16)',
    questionText: 'Want to join a follow-up survey? Drop your email (optional).',
    type: 'open-short',
    placeholder: 'your@email.com',
    required: false,
    path: null,
    blockNumber: 'final',
    accentColor: '#fff8e1',
  },
};

/**
 * Helper function to get question data by state name
 */
export const getQuestionData = (stateName: string): QuestionData | null => {
  return questionDataMap[stateName] || null;
};

/**
 * Helper to get all questions for a specific path
 */
export const getQuestionsByPath = (path: 'A' | 'B' | 'C' | 'D'): QuestionData[] => {
  return Object.values(questionDataMap).filter(q => q.path === path);
};

/**
 * Helper to get questions by block number
 */
export const getQuestionsByBlock = (blockNumber: number | 'final'): QuestionData[] => {
  return Object.values(questionDataMap).filter(q => q.blockNumber === blockNumber);
};
